// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"245898ad","453":"ef065ad0"}[chunkId] + ".chunk.js";
};